/*
  Pfeiltasten im `ShortcutBadge`: gezeichnet statt getippt, damit sie dieselbe Linie wie ↵ tragen.
  Als Schriftzeichen kamen sie aus einer Ersatzschrift — kräftiger und je nach Plattform anders.
*/
const KeyArrow = ({ d }: { d: string }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d={d} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const KeyArrowUpIcon = () => <KeyArrow d="M6 10.5V1.5M2.5 5L6 1.5L9.5 5" />
export const KeyArrowDownIcon = () => <KeyArrow d="M6 1.5V10.5M2.5 7L6 10.5L9.5 7" />
export const KeyArrowLeftIcon = () => <KeyArrow d="M10.5 6H1.5M5 2.5L1.5 6L5 9.5" />
export const KeyArrowRightIcon = () => <KeyArrow d="M1.5 6H10.5M7 2.5L10.5 6L7 9.5" />
